import { generateUtilityClass, generateUtilityClasses } from '@mui/material';
export function getDateRangePickerToolbarUtilityClass(slot) {
  return generateUtilityClass('MuiDateRangePickerToolbar', slot);
}
export const dateRangePickerToolbarClasses = generateUtilityClasses('MuiDateRangePickerToolbar', ['root', 'container']);